import type { RefInputType } from '@arco-design/web-react/es/Input';
import type { InputProps, InputRefType } from './const';
import { Input as ArcoInput } from '@arco-design/web-react';
import { cn } from '@utils';
import { forwardRef } from 'react';

import Password from './Password';
import TextArea from './TextArea';
import './index.less';

function NormalInput(props: InputProps, ref: React.Ref<RefInputType>) {
  const {
    prefix,
    size = 'default',
    variant = 'gray',
    className,
    readOnly,
    status,
    ...restProps
  } = props;

  const inputClass = cn(
    'wg-input',
    `wg-input--${size}`,
    `wg-input--${variant}`,
    {
      'wg-input--error': status === 'error',
      'wg-input--prefix': !!prefix,
      'wg-input--readonly': !!readOnly,
    },
    className,
  );

  return (
    <ArcoInput
      ref={ref}
      prefix={prefix || <></>}
      className={inputClass}
      size={size}
      data-vaul-no-drag
      {...restProps}
    />
  );
}

const InputComponent = forwardRef<RefInputType, InputProps>(NormalInput);

InputComponent.displayName = 'Input';

const Input = InputComponent as InputRefType;
Input.TextArea = TextArea;
Input.Password = Password;
Input.Group = ArcoInput.Group;
Input.Search = ArcoInput.Search;

export default Input;

export type { InputProps, PasswordProps, RefInputType, RefTextAreaType, TextAreaProps } from './const';
